// Katalog paket CCTV SATCOM (Dahua) — data dari brosur resmi SATCOM.
export const PRODUCTS = [
  { id: 1, img: "/products/1.jpg", channel: 4, cameras: 2, mp: "2MP", type: "Audio", priceOld: "Rp 3.000.000", price: "Rp 2.799.000" },
  { id: 2, img: "/products/2.jpg", channel: 4, cameras: 2, mp: "2MP", type: "Full Color Audio", priceOld: "Rp 4.000.000", price: "Rp 3.499.000" },
  { id: 3, img: "/products/3.jpg", channel: 4, cameras: 2, mp: "5MP", type: "Full Color Audio", priceOld: "Rp 4.500.000", price: "Rp 3.999.000" },
  { id: 4, img: "/products/4.jpg", channel: 4, cameras: 4, mp: "2MP", type: "Audio", priceOld: "Rp 4.300.000", price: "Rp 3.799.000" },
  { id: 5, img: "/products/5.jpg", channel: 4, cameras: 4, mp: "2MP", type: "Full Color Audio", priceOld: "Rp 5.000.000", price: "Rp 4.499.000" },
  { id: 6, img: "/products/6.jpg", channel: 4, cameras: 4, mp: "5MP", type: "Full Color Audio", priceOld: "Rp 5.700.000", price: "Rp 5.199.000" },
  { id: 7, img: "/products/7.jpg", channel: 8, cameras: 6, mp: "2MP", type: "Audio", priceOld: "Rp 6.200.000", price: "Rp 5.699.000" },
  { id: 8, img: "/products/8.jpg", channel: 8, cameras: 6, mp: "2MP", type: "Full Color Audio", priceOld: "Rp 7.600.000", price: "Rp 7.199.000" },
  { id: 9, img: "/products/9.jpg", channel: 8, cameras: 6, mp: "5MP", type: "Full Color Audio", priceOld: "Rp 9.600.000", price: "Rp 9.199.000" },
  { id: 10, img: "/products/10.jpg", channel: 8, cameras: 8, mp: "2MP", type: "Audio", priceOld: "Rp 8.200.000", price: "Rp 7.699.000" },
  { id: 11, img: "/products/11.jpg", channel: 8, cameras: 8, mp: "2MP", type: "Full Color Audio", priceOld: "Rp 9.600.000", price: "Rp 9.199.000" },
  { id: 12, img: "/products/12.jpg", channel: 8, cameras: 8, mp: "5MP", type: "Full Color Audio", priceOld: "Rp 11.600.000", price: "Rp 11.199.000" },
  { id: 13, img: "/products/13.jpg", channel: 16, cameras: 12, mp: "2MP", type: "Audio", priceOld: "Rp 11.600.000", price: "Rp 11.199.000" },
  { id: 14, img: "/products/14.jpg", channel: 16, cameras: 12, mp: "2MP", type: "Full Color Audio", priceOld: "Rp 14.600.000", price: "Rp 14.199.000" },
  { id: 15, img: "/products/15.jpg", channel: 16, cameras: 12, mp: "5MP", type: "Full Color Audio", priceOld: "Rp 17.600.000", price: "Rp 17.199.000" },
  { id: 16, img: "/products/16.jpg", channel: 16, cameras: 16, mp: "2MP", type: "Audio", priceOld: "Rp 14.600.000", price: "Rp 14.199.000" },
  { id: 17, img: "/products/17.jpg", channel: 16, cameras: 16, mp: "2MP", type: "Full Color Audio", priceOld: "Rp 18.600.000", price: "Rp 18.199.000" },
  { id: 18, img: "/products/18.jpg", channel: 16, cameras: 16, mp: "5MP", type: "Full Color Audio", priceOld: "Rp 23.300.000", price: "Rp 22.699.000" },
];

export const PRODUCT_FILTERS = [
  { key: "all", label: "Semua Paket" },
  { key: "4", label: "4 Channel" },
  { key: "8", label: "8 Channel" },
  { key: "16", label: "16 Channel" },
];

// Kategori produk utama
export const CATEGORIES = [
  { key: "cctv", label: "Paket CCTV" },
  { key: "wifi", label: "WiFi Internet" },
  { key: "parabola", label: "Parabola" },
  { key: "komputer", label: "Komputer & Laptop" },
  { key: "network", label: "Network" },
  { key: "pos", label: "POS Kasir" },
  { key: "kursus", label: "Kursus" },
];

// Paket WiFi / Internet SATCOM (dari brosur resmi Promo Merdeka)
export const WIFI_PACKAGES = [
  {
    id: "wifi-regular",
    name: "Paket Regular",
    img: "/products/wifi/regular.jpg",
    speed: "20 Mbps",
    features: [
      "Full Fiber, bukan WiFi paralel",
      "Tanpa FUP / batas kuota",
      "Unlimited perangkat",
    ],
    priceOld: "Rp 250.000",
    price: "Rp 149.990",
    period: "/bulan",
  },
  {
    id: "wifi-premium",
    name: "Paket Premium",
    img: "/products/wifi/premium.jpg",
    speed: "20 Mbps",
    popular: true,
    features: [
      "Nonton TV tanpa antena/parabola",
      "Channel olahraga & film premium",
      "Gratis akses sepak bola liga dunia & timnas",
      "Bisa untuk TV LCD atau TV tabung",
      "Gratis STB Android",
      "Full Fiber, tanpa FUP, unlimited perangkat",
    ],
    priceOld: "Rp 350.000",
    price: "Rp 199.990",
    period: "/bulan",
  },
  {
    id: "wifi-ultimate",
    name: "Paket Ultimate",
    img: "/products/wifi/ultimate.jpg",
    speed: "20 Mbps",
    features: [
      "Nonton Netflix sepuasnya tanpa langganan",
      "Nonton TV tanpa antena/parabola",
      "Channel olahraga & film premium",
      "Gratis Liga Inggris, Italia, Spanyol, Jerman, UCL, Timnas dll",
      "Bisa untuk TV LCD atau TV tabung",
      "Gratis STB Android",
      "Full Fiber, tanpa FUP, unlimited perangkat",
    ],
    priceOld: "Rp 450.000",
    price: "Rp 249.990",
    period: "/bulan",
  },
];

// Paket Parabola SATCOM (dari brosur resmi Promo Merdeka)
export const PARABOLA_PACKAGES = [
  {
    id: "parabola-mini",
    name: "Parabola Mini Merdeka",
    img: "/products/parabola/parabola-mini.jpg",
    brands: ["K-Vision", "Nex Parabola", "Transvision"],
    features: [
      "Gratis paket 1 tahun (ratusan channel premium: film, olahraga & berita)",
      "Semua paket premium K-Vision, Nex Parabola & Transvision termasuk",
      "Garansi 1 tahun untuk Set-Top Box & LNB",
      "Gratis biaya pemasangan (pemasangan standar)",
      "Gambar Full HD & jernih (bebas semut & gangguan)",
      "Ratusan channel nasional tanpa biaya bulanan tambahan setelah 1 tahun",
      "Produk asli Indonesia",
    ],
    priceOld: "Rp 1.450.000",
    price: "Rp 1.000.000",
    note: "Harga NET — sudah termasuk pemasangan",
  },
];

// Layanan Komputer & Laptop SATCOM (dari brosur resmi Promo Merdeka)
export const KOMPUTER_PACKAGES = [
  {
    id: "komputer-custom",
    name: "Rakitan Komputer Custom & Laptop",
    img: "/products/komputer/rakitan-laptop.jpg",
    tagline: "Budget Anda, Spek Anda — harga menyesuaikan unit & komponen.",
    brands: ["ASUS", "Acer", "Dell", "HP", "Zyrex", "Axio", "NVIDIA", "Intel", "AMD"],
    features: [
      "Rakitan PC custom sesuai kebutuhan & budget",
      "Penyedia laptop berbagai merek",
      "Gratis software utama: OS, driver & game populer (PC & laptop)",
      "Perakitan profesional & setup (rapi & cepat)",
      "Konsultasi gratis untuk PC/Laptop",
      "Garansi lengkap unit & komponen",
      "Garansi toko & distributor resmi 1 tahun",
      "Produk asli & berkualitas",
    ],
    price: "Mulai Rp 3.000.000",
    note: "Harga akhir menyesuaikan spesifikasi & komponen yang dipilih",
  },
];

import { Cpu as CpuIcon, MonitorPlay } from "lucide-react";

// Contoh paket rakitan PC — harga ESTIMASI, dapat disesuaikan spek & komponen.
export const KOMPUTER_BUILDS = [
  {
    id: "build-entry",
    icon: CpuIcon,
    name: "PC Entry / Kantor",
    for: "Admin, sekolah, browsing & Office",
    specs: ["Intel Core i3 / Ryzen 3", "RAM 8GB DDR4", "SSD NVMe 256GB", "Grafis onboard", "Casing + PSU"],
    priceFrom: "Estimasi mulai Rp 3.500.000",
  },
  {
    id: "build-gaming",
    icon: MonitorPlay,
    name: "PC Gaming",
    for: "Gaming & streaming lancar",
    popular: true,
    specs: ["Core i5 / Ryzen 5", "RAM 16GB DDR4/DDR5", "SSD NVMe 512GB", "GPU NVIDIA RTX", "Cooling & casing RGB"],
    priceFrom: "Estimasi mulai Rp 9.000.000",
  },
  {
    id: "build-editing",
    icon: CpuIcon,
    name: "PC Editing / Workstation",
    for: "Editing video, desain & 3D",
    specs: ["Core i7 / Ryzen 7", "RAM 32GB", "SSD NVMe 1TB", "GPU RTX seri kreator", "PSU berkualitas"],
    priceFrom: "Estimasi mulai Rp 15.000.000",
  },
];

// Layanan Network — Jasa Instalasi Server (dari brosur resmi SATCOM)
export const NETWORK_SERVICES = [
  {
    id: "net-mikrotik",
    img: "/products/network/mikrotik.jpg",
    title: "Jasa Instalasi Server MikroTik",
    tag: "MikroTik / RouterOS",
    features: [
      "Konfigurasi Routerboard",
      "Bandwidth Management",
      "Load Balancing & Failover",
      "Hotspot & User Manager",
      "VPN Setting (PPTP, L2TP, OpenVPN)",
      "Firewall Security",
    ],
    price: "Rp 1.500.000 – Rp 5.000.000+",
    priceNote: "Tergantung kebutuhan & skala",
    note: "Belum termasuk perangkat hardware.",
  },
  {
    id: "net-windows",
    img: "/products/network/windows.jpg",
    title: "Jasa Instalasi Windows Server",
    tag: "Windows Server 2022 / 2019",
    features: [
      "Active Directory (AD) Domain",
      "File & Print Server",
      "Hyper-V Virtualization",
      "Web Server (IIS)",
      "DNS & DHCP Setup",
      "Windows Update Services (WSUS)",
      "System Security & Backup",
    ],
    price: "Rp 2.500.000 – Rp 8.000.000+",
    priceNote: "Tergantung edisi & layanan",
    note: "Belum termasuk lisensi & hardware.",
  },
  {
    id: "net-linux",
    img: "/products/network/linux.jpg",
    title: "Jasa Instalasi Linux Server",
    tag: "Ubuntu / CentOS / Rocky / Debian",
    features: [
      "Web Server (Apache, Nginx)",
      "Database Server (MySQL, PostgreSQL)",
      "Mail Server (Postfix, Dovecot)",
      "FTP & SSH Access",
      "Samba File Sharing",
      "Monitoring Tools (Zabbix, Nagios)",
      "Firewall (iptables, UFW)",
    ],
    price: "Rp 2.000.000 – Rp 7.000.000+",
    priceNote: "Tergantung distro & konfigurasi",
    note: "Belum termasuk hardware.",
  },
];

// Paket POS / Mesin Kasir — SATCOM POS System (dari brosur resmi)
export const POS_BROCHURE = "/products/pos/pos.jpg";

export const POS_PACKAGES = [
  {
    id: "pos-ekonomis",
    name: "Paket Ekonomis Standar",
    for: "Ideal untuk toko retail",
    features: ["Thermal Printer", "Barcode Scanner", "Cash Drawer", "Mini PC / Laptop", "POS Software"],
    price: "Rp 5.500.000 – Rp 6.500.000",
  },
  {
    id: "pos-business",
    name: "Paket Business Pro",
    for: "Performa terbaik untuk minimarket",
    popular: true,
    features: ["Thermal Printer Cepat", "Barcode Scanner Omni", "Cash Drawer Besar", "PC Desktop", "POS Software Pro", "Fitur Inventori"],
    price: "Rp 7.000.000 – Rp 9.500.000",
  },
  {
    id: "pos-ultimate",
    name: "Paket Ultimate Touch",
    for: "All-in-One Touchscreen — cafe & restoran",
    features: ["All-in-One Touchscreen Terminal", "Thermal Printer Dapur", "Barcode Scanner Nirkabel", "Cash Drawer Premium", "POS Software Resto", "Fitur Meja & Pesanan"],
    price: "Rp 12.000.000 – Rp 15.000.000",
  },
];

// Kursus Privat Komputer (dari brosur resmi SATCOM — Pelatihan IT & Komputer)
export const KURSUS_BROCHURE = "/products/kursus/kursus.jpg";

export const KURSUS_FACILITIES = [
  "Jadwal fleksibel: pagi, siang, malam & weekend",
  "Privat 1-on-1, fokus penuh sesuai kecepatanmu",
  "80% praktek dengan studi kasus dunia kerja",
  "Sertifikat resmi untuk portofolio & CV",
  "Konsultasi gratis: bimbingan tugas & pekerjaan",
];

export const KURSUS_PROGRAMS = [
  {
    id: "kursus-office",
    no: "1",
    tag: "Administrasi",
    title: "MS Office & Admin",
    points: ["Administrasi perkantoran", "Microsoft Word, Excel & PowerPoint", "Manajemen dokumen & data"],
    price: "Rp 2.040.000",
    duration: "8 Sesi @ 90 Menit",
  },
  {
    id: "kursus-desain",
    no: "2",
    tag: "Desain Creative",
    title: "Desain Grafis",
    points: ["Dasar desain grafis kreatif", "Proyek desain visual", "Membangun portofolio desain"],
    price: "Rp 2.550.000",
    duration: "8 Sesi @ 90 Menit",
  },
  {
    id: "kursus-web",
    no: "3",
    tag: "Web Dev",
    title: "Web & Laravel",
    popular: true,
    points: ["Web development", "Web programming (Laravel)", "Dasar desktop programming"],
    price: "Rp 4.250.000",
    duration: "10 Sesi @ 120 Menit",
  },
  {
    id: "kursus-desktop",
    no: "4",
    tag: "Programming",
    title: "Desktop Programming",
    points: ["Dasar pemrograman", "Membuat aplikasi desktop", "Studi kasus riil"],
    price: "Rp 3.740.000",
    duration: "10 Sesi @ 120 Menit",
  },
  {
    id: "kursus-mikrotik",
    no: "5",
    tag: "Jaringan",
    title: "MikroTik & Jaringan",
    points: ["Konsep dasar jaringan", "Konfigurasi MikroTik", "Hotspot & routing"],
    price: "Rp 3.400.000",
    duration: "8 Sesi @ 120 Menit",
  },
  {
    id: "kursus-fiber",
    no: "6",
    tag: "Specialist",
    title: "Fiber Optic",
    points: ["Pelatihan fiber optic (specialist)", "Praktik penyambungan (splicing)", "Materi siap kerja"],
    price: "Rp 4.760.000",
    duration: "Workshop 2 Hari",
  },
];
